<template>
  <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense flat color="tertiary">
            <v-toolbar-title class="custon-toolbar-title" >Listagem</v-toolbar-title>
              <v-spacer/>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Busca rápida"
                single-line
                hide-details="auto"
              ></v-text-field>
          </v-toolbar>
          <v-card-text class="py-0">
            <v-data-table
              :headers="headers"
              :items="list"
              :item-key="list.id"
              :loading="loading"
              :options.sync="options"
              :server-items-length="paginate.total"
            >
              <template v-slot:item.ativo="{ item }">
                <v-btn fab x-small depressed tag="div"
                :color="item.ativo ? 'green lighten-4' : 'red lighten-4'">
                  <v-icon :color="item.ativo ? 'green' : 'red'"
                  small>{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.acoes="{ item }">
                <v-btn @click="edit(item)"
                  fab depressed dark x-small color="indigo lighten-4" class="mr-2">
                <v-icon color="indigo" small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn @click="destroyConfirm(item)"
                  fab depressed dark x-small color="red lighten-4">
                <v-icon color="red" small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';

export default {
  name: 'LogradouroTable',
  data: () => ({
    headers: [
      {
        text: 'Cód.',
        value: 'id',
        sortable: false,
        width: '5%',
        align: 'center',
      },
      {
        text: 'Endereço',
        value: 'nome',
        sortable: false,
      },
      {
        text: 'CEP',
        value: 'cep',
        sortable: false,
      },
      {
        text: 'Tipo Logradouro',
        value: 'tipo_logradouro.nome',
        sortable: false,
      },
      {
        text: 'Ativo',
        value: 'ativo',
        sortable: false,
        width: '8%',
        align: 'center',
      },
      {
        text: 'Ações',
        value: 'acoes',
        width: '12%',
        align: 'center',
        sortable: false,
      },
    ],
    search: null,
    options: {
      itemsPerPage: 15,
    },
    timeoutSearch: null,
  }),
  destroyed() {
    this.reset();
  },
  methods: {
    ...mapActions('logradouro', ['edit', 'getAll', 'getPageSort', 'destroy', 'reset']),
    destroyConfirm(item) {
      confirmDestroyAlert(item.nome).then((result) => {
        if (result.value) {
          this.destroy(item)
            .then(() => toastMessage.successDestroy('Logradouro excluído com sucesso'))
            .catch(() => toastMessage.errorDestroy('Erro ao excluir logradouro'));
        }
      });
    },
  },
  computed: {
    ...mapState('logradouro', ['loading', 'list', 'paginate']),
  },
  watch: {
    options(after, before) {
      if (after !== before && before !== null) {
        const params = Object.assign(after);
        params.searchBy = this.search;
        this.getPageSort(params);
      }
    },
    search(after, before) {
      if (after !== before) {
        const params = Object.assign(this.options);
        params.searchBy = this.search;
        if (after.length >= 3 || after.length === 0) {
          if (this.timeoutSearch) {
            clearTimeout(this.timeoutSearch);
            this.timeoutSearch = null;
          }
          this.timeoutSearch = setTimeout(() => {
            this.getPageSort(params);
          }, 500);
        }
      }
    },
  },
};
</script>
